import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const ProductContext = createContext();

export function ProductProvider({ children }) {
  const [pizzas, setPizzas] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [desserts, setDesserts] = useState([]);
  const [extras, setExtras] = useState([]);

  //obtener pizzas

  const getPizzas = async () => {
    const res = await axios
      .get(`${process.env.REACT_APP_LOCAL_PRODUCTOS}menu-pizzas`)
      .then((res) => {
        setPizzas(res.data);
      })
      .catch((e) => console.error(e));
  };

  const getDrinks = async () => {
    const res = await axios
      .get(`${process.env.REACT_APP_LOCAL_PRODUCTOS}menu-drinks`)
      .then((res) => {
        setDrinks(res.data);
      })
      .catch((e) => console.error(e));
  };

  const getDesserts = async () => {
    const res = await axios
      .get(`${process.env.REACT_APP_LOCAL_PRODUCTOS}menu-desserts`)
      .then((res) => {
        setDesserts(res.data);
      })
      .catch((e) => console.error(e));
  };

  const getExtras = async () => {
    const res = await axios
      .get(`${process.env.REACT_APP_LOCAL_PRODUCTOS}menu-extras`)
      .then((res) => {
        setExtras(res.data);
      })
      .catch((e) => console.error(e));
  };

  return (
    <ProductContext.Provider
      value={{
        pizzas,
        getPizzas,
        drinks,
        getDrinks,
        desserts,
        getDesserts,
        extras,
        getExtras,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}

export const useProduct = () => useContext(ProductContext);
